import type { ItemProps } from "@react-types/shared";
import type { PropsWithChildren, ReactElement } from "react";

export interface TabItemProps extends Pick<ItemProps<unknown>, "title" | "textValue" | "aria-label"> {
  //hint?: string;
  icon?: ReactElement | string;
  //description?: string;
  //hotkey?: string;
}

/**
 * The mandatory wrapper of each tab.
 * Will defines the content of the TabBar and manage the Tab content.
 */
function TabItem(_: PropsWithChildren<TabItemProps>) {
  // Only used to get props as parameters.
  // JSX is unused but children is!
  return null;
}

export { TabItem };
